import DeliveryService from "../DeliveryService"

const User = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    permission() {
        return DeliveryService.get(`/user/permission`)
    },
    me() {
        return DeliveryService.post(`/user/me`, {
            "app": "backend"
        })
    },
    getMenus() {
        return DeliveryService.get(`/console/utils/menus`)
    }
}

export default User